import * as Yup from 'yup';
import { PhoneNumberUtil } from 'google-libphonenumber';
const phoneUtil = PhoneNumberUtil.getInstance();
export const fullNameSchema = Yup.string()
    .min(2, 'Name must be at least 2 characters')
    .max(100, 'Name must be less than 100 characters')
    .matches(/^[A-Za-zÀ-ÖØ-öø-ÿ]+(?:[ '-][A-Za-zÀ-ÖØ-öø-ÿ]+)*$/, 'Name can only contain letters, spaces, hyphens and apostrophes')
    .test('no-consecutive-special', 'Name cannot contain consecutive spaces, hyphens or apostrophes', (value) => !value || !/[ '-]{2,}/.test(value))
    .trim();
export const stripLeadingPlus = (phone, mobileCountry) => {
    if (!hasRealMobileDigits(phone, mobileCountry)) {
        return '';
    }
    return phone?.replace(/^\+/, '') ?? '';
};
export const ensureLeadingPlus = (phone) => {
    const trimmedPhone = phone?.trim();
    if (!trimmedPhone) {
        return '';
    }
    return trimmedPhone.startsWith('+') ? trimmedPhone : `+${trimmedPhone}`;
};
const hasRealMobileDigits = (phone, mobileCountry) => {
    const trimmedPhone = phone?.trim();
    if (!trimmedPhone)
        return false;
    try {
        const digitsOnly = trimmedPhone.replace(/\D/g, '');
        const dialCode = mobileCountry
            ? String(phoneUtil.getCountryCodeForRegion(mobileCountry.toUpperCase()))
            : '';
        return !!digitsOnly && digitsOnly !== dialCode;
    }
    catch {
        return !!trimmedPhone;
    }
};
export const mobileSchema = (isRequired = false) => Yup.string()
    .trim()
    .test('mobile-required', 'Mobile is required', function (value) {
    if (!isRequired) {
        return true;
    }
    const mobileCountry = this.parent?.mobileCountry;
    return hasRealMobileDigits(value, mobileCountry);
})
    .test('is-valid-mobile', 'Please enter a valid mobile number', function (value) {
    const mobileCountry = this.parent?.mobileCountry;
    return isValidMobile(value, mobileCountry);
});
export const isValidMobile = (phone, phoneCountry) => {
    const normalizedPhone = phone?.trim() ?? '';
    if (!hasRealMobileDigits(normalizedPhone, phoneCountry)) {
        return true;
    }
    try {
        const normalizedCountry = phoneCountry?.toUpperCase() ?? 'NZ';
        if (phoneCountry) {
            const parsed = phoneUtil.parse(normalizedPhone, normalizedCountry);
            const valid = phoneUtil.isValidNumberForRegion(parsed, normalizedCountry);
            return valid;
        }
        else {
            const parsedRaw = phoneUtil.parseAndKeepRawInput(normalizedPhone);
            const validRaw = phoneUtil.isValidNumber(parsedRaw);
            return validRaw;
        }
    }
    catch {
        return false;
    }
};
